import "reflect-metadata";
import "vue-class-component/hooks";
import "@/globalImports/class-component-hooks";
import "@/globalImports/vue-router-hooks";
import Vue from "vue";
import App from "./App.vue";
import Maintenance from "./Maintenance.vue";
import router from "@/router";
import store from "./store";
import Plugins from "@/plugins/index";
import Buefy from "buefy";
import Vuelidate from "vuelidate";
import i18n from "./i18n";
// import '@/globalImports/froala.ts';
import "./toast-ui-calendar-dst-fix.ts";
import "sweetalert2/src/sweetalert2.scss";
import { buefyConfigs } from "@/config/buefy";
//import "froala-editor/css/froala_style.min.css";
import { registerLicense } from "@syncfusion/ej2-base";
import { GridPlugin } from "@syncfusion/ej2-vue-grids";
import { SYNCFUSION_LICENSE } from "@/config/syncfusion";
import amplitude from "@/services/amplitude";
import { getAuth0Client, runLoginCallbackSequence } from "@/services/Auth2";
import { initialize } from "@/initialized";

registerLicense(SYNCFUSION_LICENSE);
const mountApp = (el: Element | string) => {
  Vue.use(GridPlugin);

  Vue.config.productionTip = false;

  if (!["/callback"].includes(window.location.pathname)) {
    // /callback is a special route that needs to do its own business
    // on its own. We will not call initialize and let the route
    // handle itself
    getAuth0Client().then((client) => runLoginCallbackSequence(client, router));
  }

  Vue.use(Plugins);
  Vue.use(Buefy, buefyConfigs);
  Vue.use(Vuelidate);

  const isMaintenance = [1, "1", "true", true].includes(
    process.env.MAINTENANCE || false
  );

  const renderPage = isMaintenance ? Maintenance : App;

  new Vue({
    i18n,
    router,
    store,
    render: (h) => h(renderPage),
  }).$mount(el);

  initialize();
};

const root = document.querySelector("#app");
if (root) {
  mountApp(root);
}

export { mountApp, store, amplitude };
